// extracted by mini-css-extract-plugin
export default {"innerWrapper":"cA-z","tooltipWrapper":"dA-z","icon":"eA-z","tooltip":"fA-z","content":"gA-z"};